import React, { FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";
import { Alert } from "react-bootstrap";

import "./WarningAlert.scss";

interface WarningAlertProps {
    messageId: string;
    messageValues?: {};
    message?: string;
    details?: string;
}

const WarningAlert: FunctionComponent<WarningAlertProps> = props => {
    return (
        <Alert variant="warning" className="warning_alert">
            <div className="warning_alert_message">
                {props.messageId ? (
                    <FormattedMessage id={props.messageId} values={props.messageValues} />
                ) : (
                    props.message
                )}
            </div>
            {!!props.details && <div className="warning_alert_details">{props.details}</div>}
        </Alert>
    );
};

export default WarningAlert;
